export enum MediaPlatform {
  FACEBOOK = 'facebook',
  GOOGLE = 'google',
  OTHERS = 'others',
  TIKTOK = 'tiktok',
}

export enum TransactionType {
  CLEAR = 'CLEAR',
  RECHARGE = 'RECHARGE',
  REDUCED = 'REDUCED',
}
